export const headers = [
  { field: "id", headerName: "ID", width: 70, hidden: true },
  { field: "cli_codigo", headerName: "Codigo", width: 120 },
  { field: "razon_social", headerName: "Razón Social", width: 230 }, 
  { field: "cli_name", headerName: "Nombre de Fantasia", width: 230 }, 
  { field: "categ_id",headerName: "Tipo de Precio", width: 230,}
];
